import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { setOnlineState, setReminder } from "../../features/UserActions";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { decode } from "js-base64";
import { WsCmmdContext, WsContext } from "../../App";

export default function WebSocketUser() {
  //const user = useSelector((state) => state.user.detail);
  const authen = useSelector((state) => state.user.curAuthen);
  //const sckConn = useSelector((state) => state.userAction.sckFunction);
  const dispatch = useDispatch();

  const [wsCmd, setWsCmd] = useContext(WsCmmdContext);

  const socketUrl =
    process.env.REACT_APP_WSOCKET_ECHOALL +
    "?username=" +
    authen.username +
    "&password=" +
    authen.password +
    "&session_type=3&secure=y";

  const response = {
    onOpen: (e) => {
      dispatch(
        setReminder({
          show: true,
          message: "เชื่อมต่อส่วนกลางสำเร็จ",
          type: "success",
        })
      );
    },
    onMessage: (e) => {
      if (e.data) {
        /**  check response connection status from web socket server */
        if (e.data.match(/new_session_id/g)) {
          let sessionInfo = JSON.parse(e.data); // convert rad_session_id: abcdx133kk
          /** update Stae of online message */
          dispatch(
            setOnlineState({
              online: true,
              sessionId: sessionInfo.rad_session_id,
            })
          );
        } else if (e.data.match(/ReqCommand/)) {
          /** set command message */
          //setWsCmd(JSON.parse(e.data));
          document.dispatchEvent(
            new CustomEvent("wscalling", { detail: JSON.parse(e.data) })
          );
        } else {
          //** Receive message from web-socket server */
          /*
          if (user.flag_radi !== "y") {
            dispatch(
              setReminder({ show: true, message: e.data, type: "success" })
            );
          }*/
          /**  Invoken event around app to actions */
          /**  with each command from web-socket-server */

          document.dispatchEvent(
            new CustomEvent("wscalling", { detail: e.data })
          );
        }

        /** example command */
        /** {"ReqCommand":"32201","SrcStaff":5,"TargetStaff":5,"DestStaff":5,"StudyID":1,"UserID":7,"SrcSessionType":3,"TargetSessionType":2,"DestSessionType":2,"TicketID":0,"PatientName":null,"StudyInstanceUid":"1.2.410.200048.6251.20221130184647"} */
      }

      return false;
    },
    onClose: (ee, ff, gg) => {
      console.log("Web socket connection has been closed");
      /** update online state */
      dispatch(
        setOnlineState({
          online: false,
          sessionId: null,
        })
      );
    },
    onError: (e) => {
      dispatch(
        setReminder({
          show: true,
          message:
            "ไม่สามารถส่งคำสั่งไปที่ center ได้ กรุณาแจ้งผู้ดูแลระบบเพื่อตรวจสอบ",
          type: "error",
        })
      );
      console.log(e);
    },
    shouldReconnect: (ee, ff, gg) => true,
    reconnectAttemps: 100,
    reconnectInterval: 10000,
  };

  /**  variable that shared around a project to send message to socker-server */
  const [ws, setWs] = useContext(WsContext);
  const swc = useWebSocket(socketUrl, response);
  const { sendMessage, sendJsonMessage, lastMessage, readyState } = swc;

  useEffect(() => {
    setWs({
      sendMessage: (e) => {
        sendMessage(e);
      },
      sendJsonMessage: (e) => {
        sendJsonMessage(e);
      },
    });
  }, []);
}
